<template>
  <div class="filter-container flex-row">
    <div class="filter-op">
      <menu-wrapper>
        <template #menu-button="{toggleMenu}">
          <button tabindex="-1" class="btn-filter-operator" @click="toggleMenu">
            <div :class="['icon24', nativeFilterIconClass]" />
          </button>
        </template>
        <template #menu-content>
          <template v-for="(item, i) in filterOperators" :key="i">
            <menu-item
              class="filter-operator-item"
              :class="item.enumValue === operatorValue ? 'active' : ''"
              :icon="['icon24', item.icon]"
              @menu-item-click="filterOperatorItemClick(item)"
            >
              {{ item?.enumText }}
            </menu-item>
          </template>
        </template>
      </menu-wrapper>
    </div>
    <div class="filter-value flex">
      <ms-combobox-enum
        ref="thEnum"
        v-model="filterValue"
        :enum="col.enum"
        class="ms-input-filter-value"
        :title="col.tooltip || col.title || col.definition || col.caption"
        :is-show-text="false"
        :values="col.filterValue"
        :formatType="col.formatType"
        :sort-enum="col.sortEnum"
        @filterGrid="filterSearchGrid"
        :filterSeachGrid="col.filterSeachGrid"
        :custom-data="propsData.customFilterData"
        :has-border="false"
        :dropdown-width="col.dropdownWidth || 0"
        :ignore-keys="col.ignoreKeys"
        @selected="
          ({newData}) => {
            filterHeaderHandleEnum(newData, {
              operator: operatorValue,
              value: filterValue,
            });
          }
        "
        @keydown.stop=""
      />
    </div>
  </div>
</template>
<script>
import {defineComponent} from 'vue';
import msThOptionBase from '@/components/gridViewer/columnOption/MsThOptionBase.js';
import setup from '@/components/gridViewer/columnOption/render-helper.js';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
export default defineComponent({
  name: 'MsThOptionEnum',
  components: {MenuItem, MenuWrapper},
  extends: msThOptionBase,
  props: {
    filterIconClass: {
      type: String,
      default: 'ic-filter-equal',
    },
    propsData: {
      default: {},
      type: Object,
    },
  },
  setup(props, {emit}) {
    // Khai báo data variable
    const {
      nativeFilterIconClass,
      operatorValue,
      filterValue,
      filterOperators,
      filterHeaderHandleEnum,
      filterOperatorItemClick,
      removeFilter,
      thEnum,
      filterHeaderHandle,
      updateFilterValue,
    } = setup(props, {
      emit,
    });

    /**
     * custom lại oprerator
     * nnninh 07/12/2023
     */
    const handleOperator = val => {
      let rs = '';
      switch (val) {
        case '=':
          rs = 'IN';
          break;
        case '!=':
          rs = 'NOT IN';
          break;
        default:
          rs = val;
      }
      return rs;
    };

    /**
     * filter table
     * nnninh 07/12/2023
     */
    const filterSearchGrid = value => {
      filterHeaderHandle({
        operator: handleOperator(operatorValue.value),
        value: value,
      });
    };
    // Method
    // Hooks
    return {
      nativeFilterIconClass,
      filterValue,
      operatorValue,
      filterOperators,
      filterOperatorItemClick,
      filterHeaderHandleEnum,
      removeFilter,
      thEnum,
      filterSearchGrid,
      filterHeaderHandle,
      handleOperator,
      updateFilterValue,
    };
  },
});
</script>
